module.exports = __webpack_public_path__ + "media/images/admin/icons/map-pin-8c41fcd32a64210260619a622335959e.svg";